import { SVGProps } from 'react'

import { wrapIcon } from '../wrap-icon'

function SvgAcademy(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M11.612 3.084c.259-.07.532-.067.79.005l.129.042 9.233 3.518c.818.312 1.12 1.172.886 1.882V17a1 1 0 0 1-2 0V9.988l-1.15.548v5.539c0 .729-.264 1.482-.836 2.038C16.714 20.008 14.38 20.999 12 21c-2.38 0-4.714-.992-6.664-2.887-.572-.557-.836-1.311-.836-2.04v-5.385L1.702 9.417C.478 8.86.546 7.1 1.809 6.64l9.675-3.517.128-.04Zm1.028 10.718a1.5 1.5 0 0 1-1.266.012L6.5 11.597v4.477c0 .26.095.473.23.605C8.354 18.255 10.2 19 12 19c1.8 0 3.648-.745 5.27-2.32a.834.834 0 0 0 .23-.604v-4.587l-4.86 2.314Zm-8.997-5.7 8.348 3.794 7.968-3.795-7.967-3.035-8.35 3.036Z"
        fill="currentColor"
      />
    </svg>
  )
}
export default wrapIcon(SvgAcademy)
